import { memoize as _memoize } from 'lodash-es'

// Loading all the CLDR data can be expensive so cache the Format instances.
// We only support two currencies so this won't eat away at users' memory.
const getFormatter = _memoize(
  (options) => new Intl.NumberFormat('en-US', options),
  (options) => JSON.stringify(options),
)

const prettifyMoney = (n: number, { currency = 'USD', minimumFractionDigits = 2 } = {}) => {
  const formatter = getFormatter({
    style: 'currency',
    currency,
    minimumFractionDigits,
  })

  return formatter.format(n)
}

export default prettifyMoney
